const W = 1080;
const H = 1080;
const C = { green: "#083323", surface: "#0E4733", gold: "#E5A93C", terracotta: "#D96B3E", red: "#DC2626", cream: "#FAF8F5" };

const roundRect = (ctx, x, y, w, h, r) => {
  ctx.beginPath();
  ctx.roundRect(x, y, w, h, r);
  ctx.closePath();
};

const loadImage = (src) =>
  new Promise((resolve, reject) => {
    const img = new Image();
    img.crossOrigin = "anonymous";
    img.onload = () => resolve(img);
    img.onerror = reject;
    img.src = src;
  });

export const inviteUrlFor = (talantaId) => `${window.location.origin}/?ref=${encodeURIComponent(talantaId)}`;

export async function renderIdCard({ user, qrCanvas, photoUrl, badge }) {
  await Promise.all([
    document.fonts.load("800 84px Montserrat"),
    document.fonts.load("700 40px Montserrat"),
    document.fonts.load("600 34px 'Plus Jakarta Sans'"),
  ]).catch(() => {});
  const [logo, photo] = await Promise.all([
    loadImage("/logo-knockout.png").catch(() => null),
    photoUrl ? loadImage(photoUrl).catch(() => null) : Promise.resolve(null),
  ]);

  const canvas = document.createElement("canvas");
  canvas.width = W;
  canvas.height = H;
  const ctx = canvas.getContext("2d");

  ctx.fillStyle = C.green;
  ctx.fillRect(0, 0, W, H);
  const glow = ctx.createRadialGradient(W * 0.85, H * 0.15, 40, W * 0.85, H * 0.15, 700);
  glow.addColorStop(0, "rgba(229,169,60,0.22)");
  glow.addColorStop(1, "rgba(229,169,60,0)");
  ctx.fillStyle = glow;
  ctx.fillRect(0, 0, W, H);
  const glow2 = ctx.createRadialGradient(W * 0.1, H * 0.95, 40, W * 0.1, H * 0.95, 600);
  glow2.addColorStop(0, "rgba(184,90,50,0.28)");
  glow2.addColorStop(1, "rgba(184,90,50,0)");
  ctx.fillStyle = glow2;
  ctx.fillRect(0, 0, W, H);

  [C.green, C.red, C.gold, "#B85A32"].forEach((col, i) => {
    ctx.fillStyle = col;
    ctx.fillRect(i * (W / 4), 0, W / 4, 22);
  });

  if (logo) {
    const lw = 330;
    ctx.drawImage(logo, 80, 80, lw, lw * (logo.height / logo.width));
  }

  const pr = 130;
  const px = W - 80 - pr;
  const py = 90 + pr;
  ctx.save();
  ctx.beginPath();
  ctx.arc(px, py, pr + 8, 0, Math.PI * 2);
  ctx.fillStyle = C.gold;
  ctx.fill();
  ctx.beginPath();
  ctx.arc(px, py, pr, 0, Math.PI * 2);
  ctx.closePath();
  ctx.clip();
  if (photo) {
    ctx.drawImage(photo, px - pr, py - pr, pr * 2, pr * 2);
  } else {
    ctx.fillStyle = C.surface;
    ctx.fillRect(px - pr, py - pr, pr * 2, pr * 2);
    ctx.fillStyle = C.gold;
    ctx.font = "800 96px Montserrat";
    ctx.textAlign = "center";
    ctx.textBaseline = "middle";
    const initials = (user.name || "TM").trim().split(/\s+/).slice(0, 2).map((w) => w[0]?.toUpperCase()).join("");
    ctx.fillText(initials, px, py + 6);
    ctx.textAlign = "left";
  }
  ctx.restore();

  ctx.textBaseline = "alphabetic";
  ctx.fillStyle = C.gold;
  ctx.font = "700 26px Montserrat";
  ctx.letterSpacing = "6px";
  ctx.fillText("ONE TALANTA ID", 80, 360);
  ctx.letterSpacing = "0px";

  const name = (user.name || "Talanta Member").trim();
  ctx.fillStyle = "#FFFFFF";
  let size = 84;
  ctx.font = `800 ${size}px Montserrat`;
  while (ctx.measureText(name).width > W - 160 && size > 44) {
    size -= 4;
    ctx.font = `800 ${size}px Montserrat`;
  }
  ctx.fillText(name, 80, 460);

  ctx.font = "700 40px 'Courier New', monospace";
  const idText = user.talanta_id;
  const idW = ctx.measureText(idText).width + 56;
  ctx.fillStyle = "rgba(255,255,255,0.10)";
  roundRect(ctx, 80, 500, idW, 72, 16);
  ctx.fill();
  ctx.fillStyle = C.gold;
  ctx.fillText(idText, 108, 550);

  ctx.fillStyle = "rgba(255,255,255,0.75)";
  ctx.font = "600 34px 'Plus Jakarta Sans'";
  ctx.fillText(user.county ? `${user.county} County · Kenya` : "Kenya", 80, 640);

  if (badge) {
    ctx.font = "700 24px Montserrat";
    const label = `${badge.label.toUpperCase()} INVITER · ${user.invites}`;
    const bw = ctx.measureText(label).width + 48;
    ctx.fillStyle = badge.hex;
    roundRect(ctx, W - 80 - bw, 510, bw, 52, 26);
    ctx.fill();
    ctx.fillStyle = badge.id === "silver" || badge.id === "gold" ? C.green : "#FFFFFF";
    ctx.fillText(label, W - 80 - bw + 24, 545);
  }

  ctx.fillStyle = "rgba(255,255,255,0.55)";
  ctx.font = "500 26px 'Plus Jakarta Sans'";
  ctx.fillText("Sport · Digital · Soko · Education · Gaming · Broadcast", 80, 690);

  const qrBox = 300;
  const qx = W - 80 - qrBox;
  const qy = H - 80 - qrBox;
  ctx.fillStyle = "#FFFFFF";
  roundRect(ctx, qx, qy, qrBox, qrBox, 28);
  ctx.fill();
  if (qrCanvas) ctx.drawImage(qrCanvas, qx + 22, qy + 22, qrBox - 44, qrBox - 44);

  ctx.textAlign = "right";
  ctx.fillStyle = C.gold;
  ctx.font = "700 24px Montserrat";
  ctx.letterSpacing = "3px";
  ctx.fillText("SCAN TO JOIN", W - 80, qy - 28);
  ctx.letterSpacing = "0px";
  ctx.textAlign = "left";

  ctx.fillStyle = "#FFFFFF";
  ctx.font = "800 40px Montserrat";
  ctx.fillText("Monetizing Talent,", 80, H - 200);
  ctx.fillStyle = C.terracotta;
  ctx.fillText("Empowering Kenya", 80, H - 148);
  ctx.fillStyle = "rgba(255,255,255,0.6)";
  ctx.font = "600 28px 'Plus Jakarta Sans'";
  ctx.fillText("talentahela.com", 80, H - 90);

  return canvas.toDataURL("image/png");
}

export const dataUrlToFile = async (dataUrl, filename) => {
  const blob = await (await fetch(dataUrl)).blob();
  return new File([blob], filename, { type: "image/png" });
};

const drawMedal = (ctx, cx, cy, r, hex) => {
  ctx.save();
  ctx.shadowColor = hex;
  ctx.shadowBlur = 60;
  ctx.fillStyle = hex;
  ctx.beginPath();
  ctx.arc(cx, cy, r, 0, Math.PI * 2);
  ctx.fill();
  ctx.shadowBlur = 0;
  ctx.strokeStyle = "rgba(255,255,255,0.85)";
  ctx.lineWidth = 10;
  ctx.beginPath();
  ctx.arc(cx, cy, r - 18, 0, Math.PI * 2);
  ctx.stroke();
  ctx.fillStyle = "rgba(255,255,255,0.95)";
  ctx.beginPath();
  const spikes = 5;
  for (let i = 0; i < spikes * 2; i++) {
    const rad = i % 2 === 0 ? r * 0.5 : r * 0.22;
    const a = (Math.PI / spikes) * i - Math.PI / 2;
    ctx.lineTo(cx + Math.cos(a) * rad, cy + Math.sin(a) * rad);
  }
  ctx.closePath();
  ctx.fill();
  ctx.restore();
};

export async function renderBadgeCard({ user, badge, qrCanvas, photoUrl }) {
  await Promise.all([document.fonts.load("800 96px Montserrat"), document.fonts.load("600 34px 'Plus Jakarta Sans'")]).catch(() => {});
  const [logo, photo] = await Promise.all([
    loadImage("/logo-knockout.png").catch(() => null),
    photoUrl ? loadImage(photoUrl).catch(() => null) : Promise.resolve(null),
  ]);
  const canvas = document.createElement("canvas");
  canvas.width = W;
  canvas.height = H;
  const ctx = canvas.getContext("2d");

  ctx.fillStyle = C.green;
  ctx.fillRect(0, 0, W, H);
  const glow = ctx.createRadialGradient(W / 2, 400, 40, W / 2, 400, 700);
  glow.addColorStop(0, badge.hex + "55");
  glow.addColorStop(1, "rgba(0,0,0,0)");
  ctx.fillStyle = glow;
  ctx.fillRect(0, 0, W, H);
  for (let i = 0; i < 24; i++) {
    const a = (Math.PI * 2 * i) / 24;
    ctx.strokeStyle = `rgba(229,169,60,${i % 2 ? 0.05 : 0.09})`;
    ctx.lineWidth = 40;
    ctx.beginPath();
    ctx.moveTo(W / 2, 400);
    ctx.lineTo(W / 2 + Math.cos(a) * 900, 400 + Math.sin(a) * 900);
    ctx.stroke();
  }
  [C.green, C.red, C.gold, "#B85A32"].forEach((col, i) => {
    ctx.fillStyle = col;
    ctx.fillRect(i * (W / 4), 0, W / 4, 22);
  });
  if (logo) ctx.drawImage(logo, 80, 70, 260, 260 * (logo.height / logo.width));

  drawMedal(ctx, W / 2, 400, 170, badge.hex);
  if (photo) {
    ctx.save();
    ctx.beginPath();
    ctx.arc(W / 2 + 150, 520, 74, 0, Math.PI * 2);
    ctx.fillStyle = "#FFFFFF";
    ctx.fill();
    ctx.beginPath();
    ctx.arc(W / 2 + 150, 520, 66, 0, Math.PI * 2);
    ctx.clip();
    ctx.drawImage(photo, W / 2 + 84, 454, 132, 132);
    ctx.restore();
  }

  ctx.textAlign = "center";
  ctx.fillStyle = C.gold;
  ctx.font = "700 28px Montserrat";
  ctx.letterSpacing = "6px";
  ctx.fillText("BADGE UNLOCKED", W / 2, 660);
  ctx.letterSpacing = "0px";
  ctx.fillStyle = "#FFFFFF";
  ctx.font = "800 96px Montserrat";
  ctx.fillText(`I just earned ${badge.label}`, W / 2, 760);
  ctx.fillStyle = "rgba(255,255,255,0.8)";
  ctx.font = "600 34px 'Plus Jakarta Sans'";
  ctx.fillText(`${user.name || "Talanta member"} · ${user.talanta_id}`, W / 2, 820);
  ctx.fillStyle = "rgba(255,255,255,0.6)";
  ctx.font = "500 30px 'Plus Jakarta Sans'";
  ctx.fillText(`${user.invites} friend${user.invites === 1 ? "" : "s"} brought into Kenya's talent economy`, W / 2, 870);

  const q = 150;
  ctx.fillStyle = "#FFFFFF";
  roundRect(ctx, W - 80 - q, 60, q, q, 18);
  ctx.fill();
  if (qrCanvas) ctx.drawImage(qrCanvas, W - 80 - q + 12, 72, q - 24, q - 24);
  ctx.textAlign = "right";
  ctx.fillStyle = C.gold;
  ctx.font = "700 20px Montserrat";
  ctx.letterSpacing = "3px";
  ctx.fillText("SCAN TO JOIN", W - 80, 240);
  ctx.letterSpacing = "0px";
  ctx.textAlign = "left";
  ctx.fillStyle = "#FFFFFF";
  ctx.font = "800 36px Montserrat";
  ctx.fillText("Monetizing Talent,", 80, H - 150);
  ctx.fillStyle = C.terracotta;
  ctx.fillText("Empowering Kenya", 80, H - 104);
  ctx.fillStyle = "rgba(255,255,255,0.6)";
  ctx.font = "600 26px 'Plus Jakarta Sans'";
  ctx.fillText("talentahela.com · scan to join me", 80, H - 60);
  return canvas.toDataURL("image/png");
}
